import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, SxProps, Theme, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Variant } from '@mui/material/styles/createTypography';
import React, { useState } from 'react';
import { callAPI, customValidation, Method, validations } from '../../commonFunctions/CommonFunctions';
import WSPhone from '../Phone/WSPhone';
import WSSelectField from '../Select/WSSelect';
import { useSnackbar } from '../Snackbar/SnackBarContext';
import WSTextField, { CurrencyType, TextType } from '../TextBox/WSTextBox';
import { useForm } from 'react-hook-form';
interface ControlledEditLabelProps {
    id: string;
    label?: any;
    name: string;
    control: any;
    text: string;
    className?: string;
    variant?: Variant
    size?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    editType: 'text' | 'dropdown' | 'phone' | 'email' | 'amount' | 'number';
    loading?: boolean;  // Added loading prop
    color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
    onClick?: () => void;
    startIcon?: any
    endIcon?: any;
    labelSx?: SxProps<Theme>;
    textSX?: SxProps<Theme>
    apiUrl: string;
    setValue?: any
    options?: Array<any>
    updateId?:string
    reloadData?:(isreload:boolean)=>void
}

const EditLabel: React.FC<ControlledEditLabelProps> = ({ id, text,  variant, disabled, editType, loading, labelSx, textSX,  name, apiUrl,  options,label,reloadData ,updateId}) => {

    const [isEditing, setIsEditing] = useState(false);
    const [currentValue, setCurrentValue] = useState<any>(text);
    const [currentValueDropDown, setCurrentValueDropDown] = useState(text);
    const [isSaving, setIsSaving] = useState(false);
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const { showMessage } = useSnackbar();
    const handleEditClick = () => { setIsEditing(true); setValue(name, currentValue) };
    const handleCancelClick = () => {
        setIsEditing(false);
        setCurrentValue(text); 

    };
    const handleSaveClick = async (data:any) => {

        setIsSaving(true);
        try {
            const response: any = await callAPI(apiUrl, Method.PUT, { [name]: currentValue },updateId);
            
            if (response) {
                showMessage(response?.message, 'success')
                if(reloadData){
                    reloadData(true)
                }
            }
            else {
                showMessage('Error saving data:', 'error')
                setCurrentValue(text ||'')
                if(reloadData){
                    reloadData(false)
                }
            }
            setIsEditing(false);
        } catch (error) {
            showMessage('Error saving data:', 'error')
            setIsEditing(false);
        } finally {
            setIsSaving(false);
            setIsEditing(false);

        }
    };
    const handleTextChange = (evt: any) => {
        setCurrentValue(evt.target.value)
    }
    const handleNumberChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value;
      
        // Check if value is empty or not a number
        if (value === "" || isNaN(Number(value))) {
          setCurrentValue(0); // Optionally reset or handle invalid input
          return;
        }
      
        setCurrentValue(Number(value));
      };
      
    const handleDropdownChange = (evt: any) => {
        
        const selectedVal: Array<any> = options?.filter((item: any) => item?.value === evt.target.value) || [];
        setCurrentValueDropDown(selectedVal?.length > 0 ? selectedVal[0].label : '')
        setCurrentValue(evt.target.value)
    }
    return (<>
        {!isEditing && 
        <Box
            display="flex"
            alignItems="center"
            sx={{
                '&:hover .edit-icon': { opacity: 1 },
            }}
        >
            {editType !== 'dropdown' && <Typography variant={variant} sx={{ marginRight: 1,...labelSx }}>
                {currentValue}
            </Typography>}
            {editType === 'dropdown' && <Typography variant={variant} sx={{ marginRight: 1,...labelSx }}>
                {currentValueDropDown}
            </Typography>}

            <IconButton
                className="edit-icon"
                onClick={handleEditClick}
                size="small"
                sx={{ opacity: 0, transition: 'opacity 0.3s' }}
                disabled={disabled || loading}
            >
                <EditIcon sx={{ width: 15, height: 15 }} />
            </IconButton>
        </Box>

        }
        <>
        <form onSubmit={handleSubmit(handleSaveClick)}>
        {isEditing && editType === 'text' && <Box display="flex" alignItems="center" gap={1}
        ><WSTextField onTextChange={handleTextChange} control={control} name={name} id={id} sx={{ ...textSX }} label={label || ''} />
            <IconButton color="success" onClick={handleSaveClick} disabled={isSaving}>
                {isSaving ? <CircularProgress size={20} /> : <CheckIcon sx={{ width: 15, height: 15 }} />}
            </IconButton>
            <IconButton color="error" onClick={handleCancelClick} disabled={isSaving}  sx={{marginRight:2 }}>
                <CloseIcon sx={{ width: 15, height: 15 }} />
            </IconButton>
        </Box>
        }
        {isEditing && editType === 'phone' && <Box display="flex" alignItems="center" gap={1}
        ><WSPhone onTextChange={handleTextChange} control={control} name={name} id={id} label={label || ''} />
            <IconButton color="success" type='submit' disabled={isSaving}>
                {isSaving ? <CircularProgress size={20} /> : <CheckIcon sx={{ width: 15, height: 15 }} />}
            </IconButton>
            <IconButton color="error" onClick={handleCancelClick}   disabled={isSaving} sx={{marginRight:2 }}>
                <CloseIcon sx={{ width: 15, height: 15}} />
            </IconButton>
        </Box>
        }
        {isEditing && editType === 'dropdown' && <Box display="flex" alignItems="center" gap={1}
        ><WSSelectField options={options} defaultValue={currentValue} setValue={setValue} onChange={handleDropdownChange} control={control} name={name} id={id} label={label || ''} />
            <IconButton color="success" type='submit' disabled={isSaving}>
                {isSaving ? <CircularProgress size={20} /> : <CheckIcon sx={{ width: 15, height: 15 }} />}
            </IconButton>
            <IconButton color="error" onClick={handleCancelClick} disabled={isSaving}  sx={{marginRight:2 }}>
                <CloseIcon sx={{ width: 15, height: 15 }} />
            </IconButton>
        </Box>
        }
          {isEditing && editType === 'amount' && <Box display="flex" alignItems="center" gap={1}
        ><WSTextField type={TextType.Currency} currency={CurrencyType.Rupee} onTextChange={handleTextChange} control={control} name={name} id={id} sx={{ ...textSX }} label={label || ''} />
            <IconButton color="success"  type='submit' disabled={isSaving}>
                {isSaving ? <CircularProgress size={20} /> : <CheckIcon sx={{ width: 15, height: 15 }} />}
            </IconButton>
            <IconButton color="error" onClick={handleCancelClick} disabled={isSaving}  sx={{marginRight:2 }}>
                <CloseIcon sx={{ width: 15, height: 15 }} />
            </IconButton>
        </Box>
        }
        {isEditing && editType === 'email' && <Box display="flex" alignItems="center" gap={1}
        ><WSTextField type={TextType.Email}  rules={customValidation(true, validations.email)}  onTextChange={handleTextChange} control={control} name={name} id={id} sx={{ ...textSX }} label={label || ''} />
            <IconButton color="success"  type='submit' disabled={isSaving}>
                {isSaving ? <CircularProgress size={20} /> : <CheckIcon sx={{ width: 15, height: 15 }} />}
            </IconButton>
            <IconButton color="error" onClick={handleCancelClick} disabled={isSaving}  sx={{marginRight:2 }}>
                <CloseIcon sx={{ width: 15, height: 15 }} />
            </IconButton>
        </Box>
        
        }
        {isEditing && editType === 'number' && <Box display="flex" alignItems="center" gap={1}
        ><WSTextField  type={TextType.AllowOnlyNumber}   onTextChange={handleNumberChange} control={control} name={name} id={id} sx={{ ...textSX }} label={label || ''} />
            <IconButton color="success"  type='submit' disabled={isSaving}>
                {isSaving ? <CircularProgress size={20} /> : <CheckIcon sx={{ width: 15, height: 15 }} />}
            </IconButton>
            <IconButton color="error" onClick={handleCancelClick} disabled={isSaving}  sx={{marginRight:2 }}>
                <CloseIcon sx={{ width: 15, height: 15 }} />
            </IconButton>
        </Box>
        }
        </form>
        </>
    </>
    );
};

export default EditLabel